import { format } from "date-fns";

function isEmailValid(value) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return re.test(value);
}

function isPhoneValid(phone) {
  return phone.length > 13;
}

/** Rejeita sentinela típica de backend (.NET DateTime.MinValue: 0001-01-01 / 01/01/0001). */
function isSentinelCalendarDate(value) {
  if (value == null || value === "") return true;
  const s = String(value).trim();
  const br = s.match(/^(\d{1,2})[/](\d{1,2})[/](\d{1,4})(\b|T|$)/);
  if (br) {
    const d = parseInt(br[1], 10);
    const m = parseInt(br[2], 10);
    const y = parseInt(br[3], 10);
    if (d === 1 && m === 1 && y === 1) return true;
  }
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    const y = parseInt(iso[1], 10);
    const mo = parseInt(iso[2], 10);
    const da = parseInt(iso[3], 10);
    if (y <= 1 && mo === 1 && da === 1) return true;
  }
  return false;
}

function isDateValid(date) {
  if (isSentinelCalendarDate(date)) return false;
  return (
    /^(0?[1-9]|[12][0-9]|3[01])[/](0?[1-9]|1[012])[/-]\d{4}$/.test(date) ||
    /(\d{4})-(\d{2})-(\d{2})/.test(date)
  );
}

function cpfMask(value) {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
}

function cnpjMask(value) {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
}

function dateFormatter(value) {
  if (!value || isSentinelCalendarDate(value)) return "";
  return format(new Date(value), "dd'/'MM'/'yyyy");
}

function dateHourFormatter(value) {
  if (!value || isSentinelCalendarDate(value)) return "";
  return format(new Date(value), "dd'/'MM'/'yyyy HH:mm");
}

function phoneMask(value) {
  if (value.startsWith("+55")) {
    value = value.replace("+55", "");
  }

  value = value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(\d{4})-(\d)(\d{4})/, "$1$2-$3")
    .replace(/(-\d{4})\d+?$/, "$1");

  return value;
}

function cepMask(value) {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .replace(/(-\d{3})\d+?$/, "$1");
}

function pisMask(value) {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{5})(\d)/, "$1.$2")
    .replace(/(\d{5}\.)(\d{2})(\d)/, "$1$2-$3")
    .replace(/(-\d{1})\d+?$/, "$1");
}

function numeroMask(value) {
  return value.replace(/\D/g, "");
}

function formatDecimal(
  amount,
  decimalCount = 2,
  decimal = ",",
  thousands = "."
) {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    const i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    console.log(e);
  }
}

function validaCPF(cpf) {
  if (typeof cpf !== "string") return false;
  cpf = cpf.replace(/[\s.-]*/gim, "");
  if (
    !cpf ||
    cpf.length !== 11 ||
    cpf === "00000000000" ||
    cpf === "11111111111" ||
    cpf === "22222222222" ||
    cpf === "33333333333" ||
    cpf === "44444444444" ||
    cpf === "55555555555" ||
    cpf === "66666666666" ||
    cpf === "77777777777" ||
    cpf === "88888888888" ||
    cpf === "99999999999"
  ) {
    return false;
  }
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let j = 1; j <= 10; j++)
    soma = soma + parseInt(cpf.substring(j - 1, j)) * (12 - j);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
}

function validarCNPJ(cnpjData) {
  cnpjData = cnpjData.replace(/[^\d]+/g, "");

  if (!cnpjData) {
    return false;
  }

  if (cnpjData.length !== 14) {
    return false;
  }

  // Elimina cnpjDatas invalidos conhecidos
  if (
    cnpjData === "00000000000000" ||
    cnpjData === "11111111111111" ||
    cnpjData === "22222222222222" ||
    cnpjData === "33333333333333" ||
    cnpjData === "44444444444444" ||
    cnpjData === "55555555555555" ||
    cnpjData === "66666666666666" ||
    cnpjData === "77777777777777" ||
    cnpjData === "88888888888888" ||
    cnpjData === "99999999999999"
  ) {
    return false;
  }

  // Valida DVs
  let tamanho = cnpjData.length - 2;
  let numeros = cnpjData.substring(0, tamanho);
  const digitos = cnpjData.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(0))) {
    return false;
  }

  tamanho = tamanho + 1;
  numeros = cnpjData.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(1))) {
    return false;
  }

  return true;
}

function linkWhatsApp(value) {
  if (!value.startsWith("+55")) {
    value = "+55" + value.replace(/\D/g, "");
  }

  return "https://wa.me/" + value;
}

function nuloOuVazio(val) {
  return (
    val === null ||
    val === undefined ||
    (typeof val === "string" && val.trim() === "")
  );
}

function mCpfCnpj(valor) {
  if (!valor) {
    return "";
  }

  return valor.length === 11
    ? valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
    : valor.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

function endMaps(rua, nr, bairro, cidade, uf, cep) {
  let endereco = rua;
  if (!nuloOuVazio(nr)) {
    endereco += ", " + nr;
  }

  if (!nuloOuVazio(bairro)) {
    endereco += ", " + bairro;
  }

  if (!nuloOuVazio(cidade)) {
    endereco += ", " + cidade;
  }

  if (!nuloOuVazio(uf)) {
    endereco += ", " + uf;
  }

  if (!nuloOuVazio(cep)) {
    endereco += ", " + cep;
  }

  return endereco;
}

function toISOLocalDateTime(d) {
  const z = (n) => ("0" + n).slice(-2);
  const zz = (n) => ("00" + n).slice(-3);
  // var off = d.getTimezoneOffset();
  // var sign = off < 0 ? "+" : "-";
  // off = Math.abs(off);

  return (
    d.getFullYear() +
    "-" +
    z(d.getMonth() + 1) +
    "-" +
    z(d.getDate()) +
    " " +
    z(d.getHours()) +
    ":" +
    z(d.getMinutes()) +
    ":" +
    z(d.getSeconds()) +
    "." +
    zz(d.getMilliseconds())
  );
}

const MaskAndValid = {
  maskCNPJ(value) {
    return cnpjMask(value);
  },
  maskCPF(value) {
    return cpfMask(value);
  },
  maskPhone(value) {
    return phoneMask(value);
  },
  maskCEP(value) {
    return cepMask(value);
  },
  maskPIS(value) {
    return pisMask(value);
  },
  maskNumber(value) {
    return numeroMask(value);
  },
  maskPrice(value) {
    return formatDecimal(value);
  },
  maskDecimal(value, decimalCount) {
    return formatDecimal(value, decimalCount);
  },
  maskCPNJCPF(value) {
    return mCpfCnpj(value);
  },
  formattLinkWhatsApp(value) {
    return linkWhatsApp(value);
  },
  formattAddressGoogleMaps(rua, nr, bairro, cidade, uf, cep) {
    return endMaps(rua, nr, bairro, cidade, uf, cep);
  },
  isNullOrEmpty(value) {
    return nuloOuVazio(value);
  },
  validateCNPJ(value) {
    return validarCNPJ(value);
  },
  validateCPF(value) {
    return validaCPF(value);
  },
  validateEmail(value) {
    return isEmailValid(value);
  },
  validatePhone(value) {
    return isPhoneValid(value);
  },
  validateDate(value) {
    return isDateValid(value);
  },
  formattDateBR(value) {
    return dateFormatter(value);
  },
  formattDateHourBR(value) {
    return dateHourFormatter(value);
  },
  formattDateHourAPI(value) {
    return toISOLocalDateTime(value);
  },
  formatYesNo(bool) {
    return bool ? "Sim" : "Não";
  },
};

export default MaskAndValid;
